import type { SwidgeGetOutput } from '@infinex/actions';

export const ClientSwidgeStatus = {
  REQUESTED: 'Requested',
  PROCESSING: 'Processing',
  SUCCESSFUL: 'Successful',
  UNSUCCESSFUL: 'Unsuccessful',
} as const;

// TODO: @sneedinfinex move to backend
export const mapSwidgeStatusToClientStatus = (
  status: SwidgeGetOutput['status']
): (typeof ClientSwidgeStatus)[keyof typeof ClientSwidgeStatus] => {
  switch (status) {
    case 'requested':
      return ClientSwidgeStatus.REQUESTED;
    case 'open':
    case 'available':
    case 'deposited':
      return ClientSwidgeStatus.PROCESSING;
    case 'filled':
      return ClientSwidgeStatus.SUCCESSFUL;
    case 'refunded':
    case 'canceled':
    case 'failed':
      return ClientSwidgeStatus.UNSUCCESSFUL;
    default:
      return ClientSwidgeStatus.REQUESTED;
  }
};

export const isLoadingStatus = (
  status: (typeof ClientSwidgeStatus)[keyof typeof ClientSwidgeStatus]
): boolean => {
  return (
    status === ClientSwidgeStatus.REQUESTED ||
    status === ClientSwidgeStatus.PROCESSING
  );
};

export const isProcessingStatus = (
  status: (typeof ClientSwidgeStatus)[keyof typeof ClientSwidgeStatus]
): boolean => {
  return status === ClientSwidgeStatus.PROCESSING;
};

export const isTerminalStatus = (
  status: (typeof ClientSwidgeStatus)[keyof typeof ClientSwidgeStatus]
): boolean => {
  return (
    status === ClientSwidgeStatus.SUCCESSFUL ||
    status === ClientSwidgeStatus.UNSUCCESSFUL
  );
};

export const isSuccessfulStatus = (
  status: (typeof ClientSwidgeStatus)[keyof typeof ClientSwidgeStatus]
): boolean => {
  return status === ClientSwidgeStatus.SUCCESSFUL;
};

export const isErrorStatus = (
  status: (typeof ClientSwidgeStatus)[keyof typeof ClientSwidgeStatus]
): boolean => {
  return status === ClientSwidgeStatus.UNSUCCESSFUL;
};
